import _Promise from 'babel-runtime/core-js/promise';
import axios from "axios";
import { Message } from 'element-ui';
import router from '@/router';
import store from '@/vuex';

// 错误提示 页面
function showErrorPage(code, message) {
  var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  router.push({ name: 'errorPage', params: { code: code, message: message, url: url } });
}

// 请求成功拦截处理
function requestSuccess(config) {
  // 获取到用户信息并添加到请求头的token中，后端session无效时的校验
  if (store.state.userInfo.userid) {
    config.headers['x_ticket'] = store.state.userInfo.userid + '_' + store.state.userInfo.version;
  }
  // get请求IE有缓存，加时间戳清除缓存
  if (config.method === 'get') {
    config.params ? config.params['sendIeTime'] = new Date().getTime() : config.params = { sendIeTime: new Date().getTime() };
  }
  return config;
}

// post formdata 请求成功拦截处理
function requestSuccess2(config) {
  // 获取到用户信息并添加到请求头的token中，后端session无效时的校验
  if (store.state.userInfo.userid) {
    config.headers['x_ticket'] = store.state.userInfo.userid + '_' + store.state.userInfo.version;
  }

  var formData = new FormData();
  for (var i in config.data) {
    if (Array.isArray(config.data[i])) {
      config.data[i].map(function (item) {
        if (item.raw) {
          formData.append(i, item.raw);
        } else {
          formData.append(i, item);
        }
      });
    } else {
      formData.append(i, config.data[i]);
    }
  }
  config.data = formData;
  return config;
}

// 请求失败拦截处理
function requestError(error) {
  return _Promise.reject(error);
}

// 响应成功拦截
function responseSuccess(response) {
  // 请求成功
  if (response.status >= 200 && response.status < 300) {
    if (response.data.code === 200) {
      return response.data;
    } else if (response.data.code === 302) {
      debugger;
      // 重定向
      window.location.href = JSON.parse(response.data.message).redirect_url;
      return;
    } else if ([401].indexOf(response.data.code) !== -1) {
      // 未认证 提示 跳错误页
      var indexServerUrl = response.data.data.indexServer ? response.data.data.indexServer.url : null;
      showErrorPage(response.data.code, response.data.message, indexServerUrl);
    } else if (response.data.code === 601) {
      // 从门户过来的消息或任务不存在或被删除撤回
      router.push({ name: 'NoMessage' });
      return;
    } else {
      Message({
        showClose: true,
        message: response.data.message,
        type: 'error'
      });
    }
  } else if ([401, 403, 500, 501, 502, 504].indexOf(response.status) !== -1) {
    // 未认证 提示 跳错误页
    showErrorPage(response.status, response.data);
  } else {
    // error 提示
    Message({
      showClose: true,
      message: response.data.message || response.statusText,
      type: 'error',
      duration: config.timeout || 15000
    });
  }
  return _Promise.reject(response);
}

// 响应失败拦截
function responseError(error) {
  console.log('err' + error);
  return _Promise.reject(error);
}

export default function axiosSetting(config, router) {
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = config.baseName;
  axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
  axios.defaults.headers['vue-host'] = process.env.VUE_HOST;

  // get、put、delete基础请求封装
  var baseAxios = axios.create();
  baseAxios.interceptors.response.use(responseSuccess, responseError);
  baseAxios.interceptors.request.use(requestSuccess, requestError);

  // post 文件上传
  var formDataAxios = axios.create();
  formDataAxios.interceptors.response.use(responseSuccess, responseError);
  formDataAxios.interceptors.request.use(requestSuccess2, requestError);

  return {
    baseAxios: baseAxios,
    formDataAxios: formDataAxios
  };
}


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/api/http.js
// module id = null
// module chunks = 